import { getNetworkedEntity } from "../utils/scene-graph";
import { SOUND_PEN_UNDO_DRAW } from "./sound-effects-system";

AFRAME.registerComponent("undo-drawing", {
  init() {
    this.drawing = null;

    getNetworkedEntity(this.el).then(drawing => {
      this.drawing = drawing;
    });

    this.onUndoDrawing = this.onUndoDrawing.bind(this);
  },
  play() {
    this.el.object3D.addEventListener("interact", this.onUndoDrawing);
  },
  pause() {
    this.el.object3D.removeEventListener("interact", this.onUndoDrawing);
  },
  onUndoDrawing() {
    console.log("Undo drawing for ", this.drawing);
    if (!this.drawing) return;

    this.drawing.components["networked-drawing"].undoDraw();
    this.el.sceneEl.systems["hubs-systems"].soundEffectsSystem.playSoundOneShot(SOUND_PEN_UNDO_DRAW);
  }
});

AFRAME.registerComponent("delete-drawing", {
  init() {
    this.drawing = null;
    getNetworkedEntity(this.el).then(drawing => {
      this.drawing = drawing;
    });

    this.onDeleteDrawing = this.onDeleteDrawing.bind(this);
  },
  play() {
    this.el.object3D.addEventListener("interact", this.onDeleteDrawing);
  },
  pause() {
    this.el.object3D.removeEventListener("interact", this.onDeleteDrawing);
  },
  onDeleteDrawing() {
    if (!this.drawing) return;

    NAF.utils.takeOwnership(this.drawing);
    this.drawing.remove();
  }
});

AFRAME.registerComponent("serialize-drawing", {
  init() {
    this.drawing = null;
    getNetworkedEntity(this.el).then(drawing => {
      this.drawing = drawing;
    });

    this.onSerializeDrawing = this.onSerializeDrawing.bind(this);
  },
  play() {
    this.el.object3D.addEventListener("interact", this.onSerializeDrawing);
  },
  pause() {
    this.el.object3D.removeEventListener("interact", this.onSerializeDrawing);
  },
  onSerializeDrawing() {
    if (!this.drawing) return;

    this.drawing.components["networked-drawing"].serializeDrawing().then(() => {
      NAF.utils.takeOwnership(this.drawing);
      this.drawing.remove();
    });
  }
});
